import { CollectionBrowseInsideSearchFlag } from '@/api'

export interface CreateBrowseInsideRequest {
  branchCode: string
  placeCode: string
  searchFlag: CollectionBrowseInsideSearchFlag
  lendDate: string
  lendDateFrom: string
  lendDateTo: string
}

export function CreateBrowseInsideRequestToJSON(
  value: CreateBrowseInsideRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    place_code: value.placeCode !== '' ? value.placeCode : undefined,
    search_flag: value.searchFlag ? value.searchFlag : undefined,
    lend_date: value.lendDate !== '' ? value.lendDate : undefined,
    lend_date_from: value.lendDateFrom !== '' ? value.lendDateFrom : undefined,
    lend_date_to: value.lendDateTo !== '' ? value.lendDateTo : undefined
  }
}
